module.exports = __webpack_public_path__ + "img/pdf4.a7783614.jpg";